import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

import OrderStatus from '../../Orders/OrderStatus';
import {
  ORDER_STATUSES,
  TITLES as ORDER_TITLES,
} from '../../Orders/OrderStatus/constants';

import Selector, { StyledMultiValue } from '../../Common/Selector';

import { Remove as RemoveIcon } from '@icons/tagsselect';
import { ValueOf } from '@utils/tsUtils';

const { CLASS_NAME_PREFIX, StyledRemove } = Selector;

const PLACEHOLDER = 'Все статусы заказа';

const StyledTicketFilterByOrderStatus = styled(Selector)`
  border: 1px solid #e6e9ee;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 0 3px;

  ${StyledMultiValue} {
    margin: 2px 2px;
  }

  .${CLASS_NAME_PREFIX}__multi-value {
    border: none;
  }

  .${CLASS_NAME_PREFIX}__placeholder {
    color: #919499;
  }

  .${CLASS_NAME_PREFIX}__multi-value__label {
    padding: 0 0 0 10px;
    color: #4d4d4d;
  }
`;

const StyledOrderStatus = styled(OrderStatus)`
  width: fit-content;
  display: flex;
`;

const StyledMultiValueRemove = styled(StyledRemove)`
  padding: 0 0 0 5px !important;

  svg path {
    stroke: #17181a;
  }
`;

export interface TicketFilterByOrderStatusProps {
  className?: string;
  name: string;
  value?: Array<ValueOf<typeof ORDER_STATUSES>> | null;
  onChange: (event: CustomEvent) => void;
}

const TicketTypeMultiValueRemove = props => (
  <StyledMultiValueRemove {...props}>
    <RemoveIcon />
  </StyledMultiValueRemove>
);

const options = Object.values(ORDER_STATUSES).map(status => ({
  label: ORDER_TITLES[status],
  status,
  value: status,
}));

class TicketFilterByOrderStatus extends React.PureComponent<TicketFilterByOrderStatusProps> {
  el: any = null;

  static defaultProps = {
    className: '',
    name: '',
    value: null,
  };

  static renderMultiValue({ data, ...innerProps }) {
    const { status } = data;

    return (
      <div {...innerProps}>
        <StyledOrderStatus
          status={status}
          suffix={<TicketTypeMultiValueRemove {...innerProps.removeProps} />}
        />
      </div>
    );
  }

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleRef = this.handleRef.bind(this);
  }

  handleChange(value) {
    const { name, onChange } = this.props;

    const formatedValue = Array.isArray(value)
      ? value.map(v => v.status)
      : null;
    this.el.name = name;
    this.el.value = formatedValue;

    const event = new CustomEvent('change', {
      bubbles: true,
    });

    this.el.dispatchEvent(event);
    onChange(event);
  }

  handleRef(ref) {
    this.el = ReactDOM.findDOMNode(ref);
  }

  render() {
    const { value, ...props } = this.props;

    let formatedValue: Array<{
      label: string;
      status: string;
      value: string;
    }> | null = null;

    if (Array.isArray(value)) {
      formatedValue = value.map(v => ({
        label: ORDER_TITLES[v],
        status: v,
        value: v,
      }));
    }

    return (
      <StyledTicketFilterByOrderStatus
        {...props}
        components={{
          MultiValue: TicketFilterByOrderStatus.renderMultiValue,
        }}
        isMulti
        isSearchable
        onChange={this.handleChange}
        options={options}
        placeholder={PLACEHOLDER}
        ref={this.handleRef}
        value={formatedValue}
        closeMenuOnSelect={false}
        blurInputOnSelect={false}
      >
        {({ data }) => {
          const { status } = data;

          return <StyledOrderStatus status={status} />;
        }}
      </StyledTicketFilterByOrderStatus>
    );
  }
}

export default TicketFilterByOrderStatus;
